const dataArrangments = [

    {
        id: 1,
        price: 259,
        img: 'peony',
        name: 'Peony',
        category: 'WEDDING'
  },
  {
    id: 2,
    price: 150,
    img: 'eternity',
    name: 'Eternity',
    category: 'HOME DECOR'
  },
  {
    id: 3,
    price: 230,
    img: 'lily',
    name: 'Lily',
    category: 'WEDDING'
  },
  {
      id: 4,
      price: 140,
      img: 'hydrenga',
      name: 'Hydrenga',
      category: 'HOME DECOR'
  },
  {
    id: 5,
    price: 215,
    img: 'mums',
    name: 'Mums',
    category: 'THANKSGIVING'
  },
  {
    id: 6,
    price: 120,
    img: 'daisies',
    name: 'Daisies',
    category: 'WEDDING'
  },
  {
    id: 7,
    price: 75,
    img: 'roses',
    name: 'Roses',
    category: 'BIRTHDAY'
  },
  {
    id: 8,
    price: 60,
    img: 'sunflower',
    name: 'Sunflower',
    category: 'BIRTHDAY'
  },
  {
    id: 9,
    price: 120,
    img: 'lisianthus',
    name: 'Lisianthus',
    category: 'BIRTHDAY'
  },
  {
    id: 10,
    price: 115,
    img: 'ikebana',
    name: 'Ikebana',
    category: 'HOME DECOR'
  },
  {
    id: 11,
    price: 115,
    img: 'zinnias',
    name: 'Zinnias',
    category: 'THANKSGIVING'
  },
  {
    id: 12,
    price: 150,
    img: 'flora',
    name: 'Flora',
    category: 'THANKSGIVING'
  },
  {
    id: 13,
    price: 80,
    img: 'tulips',
    name: 'Tulips',
    category: 'VALENTINE'
  },
  {
    id: 14,
    price: 180,
    img: 'heart',
    name: 'Heart',
    category: 'VALENTINE'
  },
  {
    id: 15,
    price: 280,
    img: 'succulents',
    name: 'Succulents',
    category: 'VALENTINE'
  }
  ] 
  export default dataArrangments;